import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';

import { useBreadcrumbs } from '@/features/header';
import { CreateOfferDrawer } from '@/features/offers';
import { OpportunityHeaderView, OpportunityView } from '@/features/opportunities/components/opportunity-view';
import { OpportunityTopPanel } from '@/features/opportunities/components/opportunity-view/opportunity-details/opportunity-top-panel';
import { Container } from '@/components';
import { useSidebar } from '@/components/ui/sidebar';
import { cn } from '@/utils/styles';

export function Opportunity() {
  const { t } = useTranslation(['opportunities']);
  const [searchParams] = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);

  const { state } = useSidebar();
  const isCollapsed = state === 'collapsed';

  const initialTab = parseInt(searchParams.get('tab') ?? '0', 10);
  const [tabActive, setTabActive] = useState(initialTab);

  useBreadcrumbs(() => [{ title: t(`Project`) }]);
  const { opportunityId: id } = useParams();

  if (!id) return null;

  return (
    <div className="mb-10 flex flex-col pb-20 lg:mb-5 lg:pb-10">
      <div
        className={cn(
          'bg-neutral-10 fixed right-0 left-0 border-b border-neutral-50 py-4',
          'md:right-3',
          isCollapsed ? 'md:left-[60px]' : 'md:left-[220px]',
          'transition-all duration-150 ease-in-out'
        )}
        style={{ zIndex: 7 }}
      >
        <Container size="xl" className="space-y-6 px-4 sm:px-6 md:px-12">
          <OpportunityHeaderView id={id} setIsOpen={setIsOpen} />
        </Container>
      </div>

      {/* Main content */}
      <Container size="xl" className="pb-4 sm:px-6 md:px-4 md:pb-12">
        <OpportunityTopPanel id={id} tabActive={tabActive} onTabChange={setTabActive} />
        <OpportunityView id={id} />
        <CreateOfferDrawer id={id} isOpen={isOpen} setIsOpen={setIsOpen} />
      </Container>
    </div>
  );
}
